import photoComparator from "../../photoComparator/photoComparator";
import inlineGallery from "../../gallery/inlineGallery";
import LinksTooltip from "../../js/modules/linksTooltip";
import readMoreStyler from "../../js/modules/readMoreStyler/readMoreStyler";
import mainGallery from "../../gallery/mainGallery";
import bottomTagsShowMore from "../../js/news/bottomTagsShowMore";
import ViewCounter from "../../js/modules/viewCount";
import parseNewsId from "./parseNewsId";
import electionWidget from "../../js/modules/election2020/electionWidget";

export default function (title, path, opt) {
    new inlineGallery({
        dns: opt.dns,
        appVersion: opt.appVersion
    });

    new LinksTooltip();

    new electionWidget();

    new readMoreStyler();

    let newsId = parseNewsId(path);
    new mainGallery({
        dns: opt.dns,
        appVersion: opt.appVersion,
        newsId: newsId
    });

    new photoComparator();

    new bottomTagsShowMore();

    new ViewCounter({
        selector: '#views-counter-' + viewCounterObj[newsId],
        entityKey: viewCounterObj[newsId],
        apiDns: opt.viewCountServiceDns
    });
}